/*
  Usage: just inject AppColors into your component and use it as a dependency
  Example: appColors = inject(AppColors);
 */

export class AppColors {
  primary50: string;
  primary100: string;
  primary200: string;
  primary300: string;
  primary400: string;
  primary500: string;
  primary600: string;
  primary700: string;
  primary800: string;
  primary900: string;
  primary950: string;
  primary1000: string;
  secondary50: string;
  secondary100: string;
  secondary200: string;
  secondary300: string;
  secondary400: string;
  secondary500: string;
  secondary600: string;
  secondary700: string;
  secondary800: string;
  secondary900: string;
  grey50: string;
  grey100: string;
  grey200: string;
  grey300: string;
  grey400: string;
  grey500: string;
  grey600: string;
  grey700: string;
  grey800: string;
  grey900: string;
  error50: string;
  error100: string;
  error200: string;
  error300: string;
  error400: string;
  error500: string;
  error600: string;
  error700: string;
  error800: string;
  error900: string;
  success50: string;
  success100: string;
  success200: string;
  success300: string;
  success400: string;
  success500: string;
  success600: string;
  success700: string;
  success800: string;
  success900: string;
  warning50: string;
  warning100: string;
  warning200: string;
  warning300: string;
  warning400: string;
  warning500: string;
  warning600: string;
  warning700: string;
  warning800: string;
  warning900: string;
  kepple100: string;
  kepple500: string;
  kepple600: string;
  kepple700: string;
  white: string;
  black: string;
}

export type AppColorKeys = keyof AppColors;

export const corePlatformColors: AppColors = {
  primary50: '',
  primary100: '',
  primary200: '',
  primary300: '',
  primary400: '',
  primary500: '',
  primary600: '',
  primary700: '',
  primary800: '',
  primary900: '',
  primary950: '',
  primary1000: '',
  secondary50: '',
  secondary100: '',
  secondary200: '',
  secondary300: '',
  secondary400: '',
  secondary500: '',
  secondary600: '',
  secondary700: '',
  secondary800: '',
  secondary900: '',
  grey50: '',
  grey100: '',
  grey200: '',
  grey300: '',
  grey400: '',
  grey500: '',
  grey600: '',
  grey700: '',
  grey800: '',
  grey900: '',
  error50: '',
  error100: '',
  error200: '',
  error300: '',
  error400: '',
  error500: '',
  error600: '',
  error700: '',
  error800: '',
  error900: '',
  success50: '',
  success100: '',
  success200: '',
  success300: '',
  success400: '',
  success500: '',
  success600: '',
  success700: '',
  success800: '',
  success900: '',
  warning50: '',
  warning100: '',
  warning200: '',
  warning300: '',
  warning400: '',
  warning500: '',
  warning600: '',
  warning700: '',
  warning800: '',
  warning900: '',
  kepple100: '',
  kepple500: '',
  kepple600: '',
  kepple700: '',
  white: '',
  black: '',
};

const getColors = () => {
  for (const key in corePlatformColors) {
    let searchKey: string;
    if (key.search(/\d/) !== -1) {
      const position = key.search(/\d/);
      searchKey = '--' + key.slice(0, position) + '-' + key.slice(position);
    } else {
      searchKey = '--' + key;
    }

    corePlatformColors[key as keyof AppColors] = getComputedStyle(
      document.documentElement,
    ).getPropertyValue(searchKey);
  }
};

getColors();

export function AppColorsFactory(): AppColors {
  return corePlatformColors;
}
